import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateInput", "submitButton"]
  static values = {
    submitting: Boolean
  }

  connect() {
    console.log("Date selector controller connected")
    this.submittingValue = false
    
    // Add submit event listener to the form
    this.element.addEventListener('submit', this.handleSubmit.bind(this))
  }
  
  handleSubmit(event) {
    // Prevent multiple submissions
    if (this.submittingValue) {
      event.preventDefault()
      return
    }
    
    // Show loading state
    this.submittingValue = true
    document.body.classList.add('cursor-wait')
    
    // Disable the submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add('opacity-50')
    }
    
    // Add a loading overlay to the main content
    const overlay = document.createElement('div')
    overlay.id = 'loading-overlay'
    overlay.classList.add(
      'fixed', 'inset-0', 'bg-white', 'bg-opacity-75', 'flex', 
      'items-center', 'justify-center', 'z-50', 'dark:bg-gray-900', 'dark:bg-opacity-75'
    )
    overlay.innerHTML = `
      <div class="text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 dark:border-blue-400"></div>
        <p class="mt-2 text-gray-700 dark:text-gray-300">Loading dashboard for ${this.dateInputTarget.value}...</p>
      </div>
    `
    document.body.appendChild(overlay)
    
    // Form will submit naturally
  }
}
